import { render, staticRenderFns } from "./HourCustomerSidemenu.vue?vue&type=template&id=672bf9f8&scoped=true&"
import script from "./HourCustomerSidemenu.vue?vue&type=script&lang=js&"
export * from "./HourCustomerSidemenu.vue?vue&type=script&lang=js&"
import style0 from "./HourCustomerSidemenu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HourCustomerSidemenu.vue?vue&type=style&index=1&id=672bf9f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672bf9f8",
  null
  
)

export default component.exports